import styled from 'styled-components';
import { GridItem, GridRow } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const StyledCardGroup = styled(GridRow)`
	&& {
		column-gap: var(--spacing-global-space5);
		row-gap: var(--spacing-global-space7);
	}
`;

const StyledTextWrapper = styled(GridItem).attrs({
	className: 'fuse-card-group__text-wrapper',
	'data-testid': 'fuse-card-group-text-wrapper',
})`
	gap: var(--spacing-global-space3);
	display: flex;
	flex-direction: column;
`;

const StyledTitle = styled(TypographyComponent).attrs({
	className: 'fuse-card-group__title',
	'data-testid': 'fuse-card-group-title',
})`
	margin-bottom: 0;
`;

const StyledDescription = styled(TypographyComponent).attrs({
	className: 'fuse-card-group__video-description',
	'data-testid': 'fuse-card-group-video-description',
})`
	margin-bottom: 0;
`;

export { StyledCardGroup, StyledTextWrapper, StyledTitle, StyledDescription };
